// NextPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import booksData from './booksData';
import './NextBook.css';
import BookStatusBar from './BookStatusBar';

const getBookById = (id) => {
  return booksData.flatMap(series => series.books).find(book => book.id === id);
};

const Book2 = getBookById(3);

const NextPage = () => {
  if (!Book2) return null;

  const pageUrl = 'https://jerryevanoff.com/next';
  const pageTitle = 'Coming Next in the Sam Norris Murder Mystery Series | Jerry Evanoff';
  const pageDescription =
    'See what is coming next in Jerry Evanoff’s Sam Norris Murder Mystery Series, featuring modern whodunits, amateur sleuth mysteries and tech-savvy programmer Sam Norris.';

  const makeAbsoluteUrl = (url) => {
    if (!url) {
      return 'https://jerryevanoff.com';
    }

    if (url.startsWith('http')) {
      return url;
    }

    return `https://jerryevanoff.com${url.startsWith('/') ? '' : '/'}${url}`;
  };

  const coverImage = makeAbsoluteUrl(Book2.cover);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    url: pageUrl,
    description: pageDescription,
    author: {
      '@type': 'Person',
      name: 'Jerry Evanoff',
      url: 'https://jerryevanoff.com'
    },
    mainEntity: {
      '@type': 'Book',
      name: Book2.title,
      author: {
        '@type': 'Person',
        name: 'Jerry Evanoff',
        url: 'https://jerryevanoff.com'
      },
      isPartOf: {
        '@type': 'BookSeries',
        name: 'Sam Norris Murder Mystery Series',
        url: 'https://jerryevanoff.com/books'
      },
      description: Book2.shortDescription || pageDescription,
      image: coverImage,
      url: Book2.webLink
        ? makeAbsoluteUrl(Book2.webLink)
        : pageUrl
    }
  };

  return (
    <section className="next-page">
      <Helmet>
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />

        <meta
          name="keywords"
          content="Jerry Evanoff, Sam Norris Murder Mystery Series, amateur sleuth mystery, modern whodunit, tech-savvy sleuth, programmer detective, soft-boiled mystery, mystery series"
        />

        <meta name="author" content="Jerry Evanoff" />

        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={coverImage} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="Jerry Evanoff" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={coverImage} />

        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
      </Helmet>

      <div className="hero-simple">
        <h1 className="coming-next-label">
          Coming Next in the Sam Norris Series (Available 11/24/26)
        </h1>

        <div className="hero-row">
          <img src={Book2.cover} alt={Book2.title} className="hero-cover" />

          <div className="hero-text">
            <p
              className="book-description"
              dangerouslySetInnerHTML={{ __html: Book2.nextDescription }}
            ></p>

            {Book2.showBuyButton && Book2.buyLink && (
              <a
                href={Book2.buyLink}
                className="order-now-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Preorder Now
              </a>
            )}
          </div>
        </div>

        <BookStatusBar status={Book2.status} />

        <div className="start-series-cta">
          <p className="start-series-text">
            New to the series?{' '}
            <Link to="/books/manufacturing-murder">
              Start with Book 1 here.
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default NextPage;